import React from 'react';
import { Card } from '../../../shared/components';
import type { VerifyResult } from '../../../shared/api';

interface VerifyCardProps {
  result: VerifyResult;
}

const Badge: React.FC<{ value: string }> = ({ value }) => {
  const isPass = value.toLowerCase() === 'pass';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${
      isPass ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
    }`}>
      <span className={`h-1.5 w-1.5 rounded-full ${isPass ? 'bg-green-500' : 'bg-red-500'}`} />
      {value}
    </span>
  );
};

/** Tarjeta con el resultado de Microblink Verify. */
export const VerifyCard: React.FC<VerifyCardProps> = ({ result }) => {
  if (!result.verification) return null;
  const { certaintyLevel, type, result: res, performedChecks } = result.verification;
  return (
    <Card title="Verificación Microblink">
      <div className="flex flex-wrap items-center gap-4">
        <Badge value={res} />
        <div className="flex flex-wrap gap-4 text-sm text-gray-600">
          <span><span className="font-medium text-gray-400">Tipo: </span>{type}</span>
          <span><span className="font-medium text-gray-400">Nivel de certeza: </span>{certaintyLevel}</span>
          <span><span className="font-medium text-gray-400">Verificaciones: </span>{performedChecks}</span>
        </div>
      </div>
    </Card>
  );
};
